import React from 'react';
import { useAppSelector } from '../../data/store';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import Coupon from '../coupon/coupon';
import InstantSavings from '../instant-savings/instant-savings';
import Step1ProceedToCheckoutBtn from '../step-1/step-1-proceed-to-checkout-btn';
import FreePluginBox from '../free-plugin/free-plugin-box';
import { isConfirmationMsgVisible } from '../../domain/free-plugin-provider';
import SubscriptionOverviewItem from '../subscription/subscription-overview-item';
import ReferCredit from '../refer-credit/refer-credit';
import ReferCreditRecurring from '../refer-credit/credit-recurring';

const Step1Overview = () => {

    const cartData = useAppSelector(store => store.root.cartData);
    const priceData = cartData.priceData;

    return (
        <div className="bg-white border rounded w-full md:w-4/12 lg:w-1/4 md:top-60px sticky self-start">
            <div className="m-6">

                {
                    priceData.subTotalPrice !== priceData.totalPrice &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Subtotal</span>
                        <span className="ml-2"><ProductPriceFormat price={ priceData.subTotalPrice } /></span>
                    </div>
                }

                {
                    priceData.shipping > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Shipping</span>
                        <span className="ml-2"><ProductPriceFormat price={ priceData.shipping } /></span>
                    </div>
                }

                {
                    priceData.taxWithoutShippingTax > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Tax</span>
                        <span className="ml-2"><ProductPriceFormat price={ priceData.taxWithoutShippingTax } /></span>
                    </div>
                }

                {
                    priceData.shippingTax > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Shipping Tax</span>
                        <span className="ml-2"><ProductPriceFormat price={ priceData.shippingTax } /></span>
                    </div>
                }

                {
                    priceData.totalDiscountPrice > 0 &&
                    <div className="text-green font-bold flex items-center justify-between mb-4">
                        <span className="mr-2">Discounts</span>
                        <span className="ml-2" data-qa="cart-step1-discounts-price">-<ProductPriceFormat price={ priceData.totalDiscountPrice } /></span>
                    </div>
                }

                <div className="text-3xl text-gray-700 flex items-center justify-between mb-4">
                    <span className="mr-2">Order Total</span>
                    <span className="ml-2" data-qa="cart-step1-total-price"><ProductPriceFormat price={ priceData.totalPrice } /></span>
                </div>

                <SubscriptionOverviewItem />

                <Coupon />
                <InstantSavings />
                { isConfirmationMsgVisible(cartData) && <FreePluginBox /> }

                <ReferCredit />
                <ReferCreditRecurring />

                <Step1ProceedToCheckoutBtn classes="w-btn xl:text-xl font-normal py-3 mt-10 whitespace-nowrap" />
            </div>
        </div>
    )
};

export default Step1Overview;